import { useParams } from "@tanstack/react-router";

export function StatusPage() {
  const { txHash } = useParams({ from: "/status/$txHash" });

  return (
    <div className="mx-auto max-w-lg">
      <div className="rounded-lg border border-border bg-bg-panel p-6">
        <h2 className="text-lg font-semibold mb-2">Transaction Status</h2>
        <p className="text-text-secondary font-mono text-sm break-all">{txHash}</p>
      </div>
    </div>
  );
}
